var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumenticon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 90,
    viewBox: "0 -960 960 960",
    width: 90,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342.961-264.923h274.578v-36.923H342.961v36.923Zm0-158.769h274.578v-36.924H342.961v36.924Zm-76.036 297.538q-25.786 0-43.586-17.8-17.801-17.801-17.801-43.569v-584.954q0-25.768 17.801-43.569 17.8-17.8 43.738-17.8H580l174.462 173.961v472.193q0 25.937-17.801 43.738-17.8 17.8-43.586 17.8h-426.15Zm294.921-515.077v-155.692H267.077q-9.231 0-16.923 7.692-7.692 7.692-7.692 16.923v584.616q0 9.231 7.692 16.923 7.692 7.692 16.923 7.692h425.846q9.231 0 16.923-7.692 7.692-7.692 7.692-16.923v-453.539H561.846ZM242.462-796.923v155.692-155.692 633.846-633.846Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumenticon);
export default __webpack_public_path__ + "static/media/document.icon.bfe950b98b2f5468bd9faff6a576f71d.svg";
export { ForwardRef as ReactComponent };